/* ProGym — print-shop motion. GPU transforms only. One shared
   IntersectionObserver. Honours prefers-reduced-motion AND the
   merchant master toggle (data-reduce-motion on <html>). */
(function () {
  "use strict";

  var root = document.documentElement;
  var forced = root.getAttribute("data-reduce-motion") === "true";
  var mq = window.matchMedia("(prefers-reduced-motion: reduce)");
  function reduced() { return forced || mq.matches; }

  /* ---- Grain flicker (kill entirely when reduced) ---- */
  function grain() {
    var g = document.querySelector(".grain");
    if (!g || reduced()) return;
    var raf, t = 0;
    function tick() {
      t += 0.05;
      var base = parseFloat(getComputedStyle(root).getPropertyValue("--grain-opacity")) || 0.06;
      g.style.opacity = (base + Math.sin(t) * 0.012).toFixed(4);
      raf = requestAnimationFrame(tick);
    }
    tick();
    document.addEventListener("visibilitychange", function () {
      if (document.hidden) { cancelAnimationFrame(raf); } else { tick(); }
    });
  }

  /* ---- Reveal on scroll (paper slide / stamp / badge bounce) ---- */
  function reveals() {
    var els = [].slice.call(document.querySelectorAll("[data-reveal]"));
    if (!("IntersectionObserver" in window) || reduced()) {
      els.forEach(function (el) { el.setAttribute("data-revealed", "true"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          var el = e.target;
          var d = el.getAttribute("data-reveal-delay");
          if (d) el.style.transitionDelay = d + "ms";
          el.setAttribute("data-revealed", "true");
          io.unobserve(el);
        }
      });
    }, { threshold: 0.14, rootMargin: "0px 0px -8% 0px" });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---- Header (mobile) ---- */
  function header() {
    var h = document.querySelector("[data-header]");
    if (!h) return;
    var btn = h.querySelector("[data-header-toggle]");
    if (!btn) return;
    btn.addEventListener("click", function () {
      var open = h.getAttribute("data-open") === "true";
      h.setAttribute("data-open", String(!open));
      btn.setAttribute("aria-expanded", String(!open));
    });
  }

  function init() { grain(); reveals(); header(); }
  if (document.readyState !== "loading") init();
  else document.addEventListener("DOMContentLoaded", init);
})();
